import React, { FC } from 'react';
import { LandingPageStepContent } from './LandingPageStepContent';
import styles from '../LandingPageStep.scss';

export const LandingPageStepMobile: FC = () => {
  return (
    <div className={styles.landingPageStepMobile}>
      <LandingPageStepContent />
    </div>
  );
};
